import { Flex, Text } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getOrigin } from "src/environment";
import { useTheme } from "src/hooks";
import { HomeLogbookOpenBtn, OpenButton } from "src/pages/Home/Home.styled";
import type { TLogbookStatus } from "src/pages/Home/Home.types";
interface Props {
  lbid: string;
  open: number;
  restricted?: boolean;
  userAllowed?: boolean;
  showPreview?: boolean;
  status: TLogbookStatus | null;
  description?: string;
  lbjpg?: string;
  geLockedLog?: boolean;
  reverify?: number;
}
const LogbookCardDetails = ({
  geLockedLog,
  reverify,
  restricted,
  userAllowed,
  status,
  lbjpg,
  showPreview,
  open,
  description,
  lbid,
}: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const showLock = useMemo(
    () => geLockedLog || (restricted && userAllowed),
    [geLockedLog, restricted, userAllowed],
  );
  const showExpired = useMemo(
    () => status === "expired" && !open,
    [status, open],
  );

  return (
    <Flex w="100%" direction="column" style={{ flexGrow: 1 }}>
      {(description || lbjpg) && (
        <Flex w="100%" h={36} gap={16} align="center" style={{ flexGrow: 4 }}>
          <Text size="xs">{description}</Text>
          {lbjpg && (
            <img
              src={`${getOrigin()}/static/${lbjpg}`}
              style={{ height: 90, transform: "translateY(-5%)" }}
            />
          )}
        </Flex>
      )}
      <Flex
        w="100%"
        direction="column"
        gap={10}
        justify="flex-end"
        style={{ flexGrow: 1 }}>
        {(showExpired || showLock || showPreview) && (
          <Flex
            justify="flex-end"
            align="center"
            gap={10}
            style={{ width: "100%" }}>
            {showExpired ? <Text>Expired</Text> : null}
            {showLock ? <IconLock color={theme.colors.main[9]} /> : null}
            {showPreview && (
              <HomeLogbookOpenBtn>
                <OpenButton
                  onClick={() => navigate(`/logbook-preview/${lbid}/false`)}
                  variant="outline">
                  Preview
                </OpenButton>
              </HomeLogbookOpenBtn>
            )}
          </Flex>
        )}

        <Flex
          justify={reverify && open ? "space-between" : "flex-end"}
          align="center"
          gap={10}>
          {reverify ? (
            <HomeLogbookOpenBtn>
              <OpenButton variant="outline" color="orange.4">
                Re-Verify: {reverify}
              </OpenButton>
            </HomeLogbookOpenBtn>
          ) : null}
          {open ? (
            <HomeLogbookOpenBtn>
              <OpenButton variant="outline" color="orange.4">
                Open: {open}
              </OpenButton>
            </HomeLogbookOpenBtn>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
};
export default LogbookCardDetails;
